@if (formattedSummaryCards?.length) {
    <div class="grid mb-4">
        @for (cardData of formattedSummaryCards; track $index) {
            <div class="g-col-12 g-col-md-6 g-col-xl-3">
                <wdx-info-card class="h-100">
                    <div
                        wdxInfoCardLeading
                        wdxInfoCardSeparator
                        class="separator"
                    >
                        <wdx-icon-container class="bg-icon" size="md">
                            <wdx-icon icon="chart-column"></wdx-icon>
                        </wdx-icon-container>
                    </div>
                    <div wdxInfoCardLabel>
                        {{ cardData.valueLabel }}
                        ({{ cardData.percentage > 0 ? '+' : '-'
                        }}{{ cardData.percentage | percent }})
                    </div>
                    <div wdxInfoCardSub>
                        {{ cardData.label | translateTokenisedString }}
                    </div>
                </wdx-info-card>
            </div>
        }
    </div>
}

<wdx-tabs class="d-flex flex-column overflow-hidden mb-2 border-bottom">
    @for (tab of chartTabs?.tabs || []; track $index) {
        <li wdxTab>
            <a
                wdxTabLink
                [attr.data-cy]="'performance-tab-' + tab"
                [class.active]="tab === chartTabs?.selected"
                (click)="selectTab(tab)"
            >
                {{
                    chartTabs?.config?.[tab]?.label || tab
                        | translateTokenisedString
                }}
            </a>
        </li>
    }
</wdx-tabs>

<div class="p-2 p-lg-3 mb-3 bg-secondary-light bg-opacity-25">
    <div class="d-flex align-items-center">
        <h6 class="flex-shrink-0 pe-3">
            {{ 'PORTOFOLIO_INSIGHTS_VIEW_DATES' | translateTokenisedString }}
        </h6>
        <wdx-radio-button-group
            [buttonsConfig]="dateFiltersConfig"
            [checkedValue]="selectedDateRange"
            (wdxClicked)="dateFilterSelection($event)"
        ></wdx-radio-button-group>
    </div>
</div>

@if (!dataConnectionError && status === 'loaded') {
    @if (chartOptions) {
        <highcharts-chart
            class="chart"
            [Highcharts]="Highcharts"
            [options]="chartOptions"
        ></highcharts-chart>
    }
} @else {
    <div class="p-5">
        <wdx-portfolio-not-loaded
            class="p-5"
            [status]="dataConnectionError ? 'dataConnectionError' : status"
            [connectionErrorMessage]="dataConnectionError?.detail ?? ''"
            [dataTypeLabel]="dataTypeLabel"
        ></wdx-portfolio-not-loaded>
    </div>
}
